"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isWeakMap = void 0;
exports.isWeakMap = (value) => value instanceof WeakMap;
//# sourceMappingURL=is-weak-map.js.map